import { MeasurementSchema, type Measurement } from '@vy/types';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { invalidateMetersQueries } from '../../utils/query-invalidation';

export function useDeleteMeasurement(options?: UseMutationOptions<Measurement, unknown, string>) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id) => {
      const api = getPrivateApi();

      const deleteMeasurementResponse = await api.deleteMeasurement({
        measurementId: id,
      });

      return MeasurementSchema.parse(deleteMeasurementResponse);
    },
    onSuccess: async () => {
      await invalidateMetersQueries(queryClient);
    },
    ...options,
  });
}
